import React, {useState, useEffect} from "react";
import { useCookies } from 'react-cookie';
import Header from "../../components/header";
import styles from "./Presupuestos.module.css";
import MenuCard from "../../components/menu-card";
import History from "../../components/history";
import documentIcon from '@iconify/icons-jam/document';
import walletFilled from "@iconify/icons-ant-design/wallet-filled";
import systemSettings from '@iconify/icons-ic/round-settings';
import {checkSession} from "../../core/session";


const Presupuestos = (props) => {

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);

    const history = [
        {
            name: "Inicio",
            path: "/"
        }
    ]    

    const isSupervisor = () => {
        if(cookie.kUserSession == undefined || cookie.kUserSession == null){
            return false;
        }
        return cookie.kUserSession.data.rol_id == 1;
    }

    useEffect(() => {
        checkSession("home", props.history, cookie.kUserSession);
    }, []);

    return (
        <>
            <Header history={props.history}/>
            <section className={styles.body}>
                <History items={history} current={"Presupuestos"} history={props.history}/>
                <section className={styles.content}>
                    <h1 className={styles.title}>Presupuestos</h1>
                    <section className={styles.menuGroup}>
                        {
                            (isSupervisor()) ? (
                                <>
                                    <MenuCard history={props.history} menu="Informes" representation={documentIcon} path={"/presupuestos/informes"}/>
                                    <MenuCard history={props.history} menu="Planificación" representation={walletFilled} path={"/presupuestos/planificacion"}/>
                                    <MenuCard history={props.history} menu="Configuración" representation={systemSettings} path={"/presupuestos/configuracion"}/>
                                </>
                            ) : (<></>)
                        }
                    </section>
                </section>
            </section>                
        </>
    );

};

export default Presupuestos;